import { LINKS } from "./links";

const FinalCta = () => (
  <section id="contact" data-testid="final-cta-section" className="border-t border-[var(--line)]">
    <div className="container-x px-6 pt-20">
      <div className="overflow-hidden rounded-md border border-[var(--line)]">
        <img
          src="/images/intuitive-shoes-high-tops.webp"
          alt="Intuitive Shoes high-top sneakers"
          data-testid="final-cta-image"
          className="aspect-[16/5] w-full object-cover"
          loading="lazy"
        />
      </div>
    </div>

    <div className="container-x px-6 py-24 text-center md:py-32">
      <h2 className="font-display mx-auto max-w-2xl text-4xl leading-[1.1] tracking-tight sm:text-5xl">
        Let's make online fit more intuitive.
      </h2>
      <p className="mx-auto mt-6 max-w-lg text-base leading-relaxed text-[var(--ink-soft)]">
        Interested in Intuitive Shoes as a retailer, pilot partner or ecommerce
        technology partner?
      </p>
      <a href={LINKS.CONTACT_URL} data-testid="final-cta-contact-btn" className="btn-primary mt-10">
        Let's Talk
      </a>
    </div>
  </section>
);

export default FinalCta;
